export function resolveFileExtension(filename) {
    return filename.split(".").pop();
}

export function resolveFileColor(filename) {
    const extension = resolveFileExtension(filename);
    switch (extension) {
        case "jpg":
        case "jpeg":
        case "png":
        case "svg":
        case "bmp":
            return "#682338";
        case "pdf":
            return "#A10101";
        case "xlsx":
        case "xls":
        case "csv":
            return "#217346";
        case "doc":
        case "docx":
        default:
            return "#682338";
    }
}

export function resolveFileIconName(filename) {
    const extension = resolveFileExtension(filename);
    switch (extension) {
        case "mp4":
        case "mov":
        case "avi":
        case "wmv":
        case "m4v":
            return "FileVideoIcon";
        case "jpg":
        case "jpeg":
        case "png":
        case "svg":
        case "bmp":
            return "FileIcon";
        case "pdf":
            return "FilePdfIcon";
        case "xlsx":
        case "xls":
        case "csv":
            return "FileExcelIcon";
        case "doc":
        case "docx":
            return "FileWordIcon";
        default:
            return "FileIcon";
    }
}
export function resolveFileType(filename) {
    const extension = resolveFileExtension(filename);
    switch (extension) {
        case "mp4":
        case "mov":
        case "avi":
        case "wmv":
        case "m4v":
            return "video";
        case "jpg":
        case "jpeg":
        case "png":
        case "svg":
        case "bmp":
            return "file";
        case "pdf":
            return "pdf";
        case "xlsx":
        case "xls":
        case "csv":
        case "xla":
        case "xlam":
        case "xll":
        case "xlm":
        case "xlsm":
        case "xlt":
        case "xltm":
        case "xltx":
            return "excel";
        case "doc":
        case "docx":
        case "docm":
        case "dot":
        case "dotx":
            return "word";
        case "pot":
        case "potm":
        case "potx":
        case "ppam":
        case "pps":
        case "ppsm":
        case "ppsx":
        case "ppt":
        case "pptm":
        case "pptx":
            return "powerpoint";
        default:
            return "file";
    }
}

export function base64ToBlobUrl({ base, mimeType }) {
    const byteCharacters = atob(base);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {
        type: mimeType,
    });
    const blobUrl = URL.createObjectURL(blob);

    return blobUrl;
}
